<template>
  <Vue3Marquee v-bind="attrs">
    <slot></slot>
  </Vue3Marquee>
</template>
<script setup lang="ts">
import { Vue3Marquee } from 'vue3-marquee'
const attrs = useAttrs();
</script>